"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b, _c;
"use strict";
const __1 = require("..");
class OMUser extends __1.OMParty {
    constructor(object) {
        super(Object.assign({}, object, { permissions: 755 }));
        this.status = object.status || "active";
        this.identityCount = object.identityCount || 0;
        this.installationCount = object.installationCount || 0;
        this.groupCount = object.groupCount || 0;
        this.sessionCount = object.sessionCount || 0;
        this.groups = object.groups
            ? object.groups
                .map((group) => new __1.OMReference(__1.OMGroup, group))
            : [];
        this.identities = object.identities
            ? object.identities
                .map((identity) => new __1.OMReference(__1.OMIdentity, identity))
            : [];
        this.profile = object.profile && new __1.OMReference(__1.Profile, object.profile);
        this.profiles = object.profiles
            ? object.profiles
                .map((profile) => new __1.OMReference(__1.Profile, profile))
            : [];
        this.identityUsername = object.identityUsername;
        this.identityVerifiedEmails = object.identityVerifiedEmails || [];
        this.identityVerifiedPhones = object.identityVerifiedPhones || [];
    }
    static isType(object) {
        return object.type === "user" || object.objectType === "user";
    }
    suspend(reason) {
        try {
            const command = new OMUser.SuspendCommand(this, reason);
            return __1.CommandManager.shared.addToQueue(command)
                .then(() => {
                this.status = "suspended";
                __1.OMUniverse.shared.touch(this);
            });
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    unsuspend() {
        try {
            const command = new OMUser.UnsuspendCommand(this);
            return __1.CommandManager.shared.addToQueue(command)
                .then(() => {
                this.status = "active";
                __1.OMUniverse.shared.touch(this);
            });
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    deactivate() {
        try {
            const command = new OMUser.DeactivateCommand(this);
            return __1.CommandManager.shared.addToQueue(command)
                .then(() => {
                this.status = "deactivated";
                __1.OMUniverse.shared.touch(this);
            });
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
OMUser.Type = "user";
OMUser.Path = "users";
OMUser.SuspendCommand = (_a = class SuspendCommand extends __1.Command {
        constructor(receiver, reason) {
            super(receiver);
            this.reason = reason;
        }
    },
    _a.Path = "suspend",
    _a.Type = "suspend_command",
    _a);
OMUser.UnsuspendCommand = (_b = class UnsuspendCommand extends __1.Command {
        constructor(receiver) {
            super(receiver);
        }
    },
    _b.Path = "unsuspend",
    _b.Type = "unsuspend_command",
    _b);
OMUser.DeactivateCommand = (_c = class DeactivateCommand extends __1.Command {
        constructor(receiver) {
            super(receiver);
        }
    },
    _c.Path = "deactivate",
    _c.Type = "deactivate_command",
    _c);
exports.default = OMUser;
//# sourceMappingURL=OMUser.js.map